module.exports = __webpack_public_path__ + "img/reddit.b2b64e5c.svg";